module.exports = __webpack_public_path__ + "img/bg.f336134b.jpg";